<template>
    <div id="contact">
        <div class="contactContainer">
            <div class="pull-left logoContainer">
                <p>
                    <img src="../../../static/images/logo1.png" alt="logo">
                    <span>微解药</span>
                </p>
                <div>
                    <p>客服电话: 010-59942030</p>
                    <p>邮箱: service@vjieyao.com</p>
                    <p style="width: 100%;word-wrap: break-word; word-break: normal; ">公司地址: 北京市亦庄经济开发区天华北街11号富兴国际2号楼13层</p>
                </div>
            </div>
            <div class="pull-right codeContainer">
                <img src="../../../static/images/code.png" alt="code">
                <div style="display: inline-block" class="guanzhu">
                    <p>扫码关注</p>
                    <p>“微解药”公众号</p>
                </div>
                <div>
                    <!-- <p><a href="http://beian.miit.gov.cn/">公司备案: 京ICP备13025155号-3</a>  京公网安备 11030102010113号</p> -->
                    <p>公司名称: 微解药（北京）科技有限公司</p>
                    <p>Copyright：Copyright©微解药 All rights reserved</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "contact"
    }
</script>

<style scoped lang="scss">
    #contact{
        width: 100%;
        background: #f9f9fd;
        .contactContainer{
            width: 80%;
            padding: 80px 0;
            margin: 0 auto;
            overflow: hidden;
            .logoContainer{
                width: 50%;
                >div{
                    margin-top: 20px;
                  }
                span{
                    font-size: 22px;
                    color: #282829;
                }
                p{
                    font-size: 18px;
                    line-height: 2;
                    color: #282829;
                }
                img{
                    width: 176px;
                    height: 176px;
                }
            }
            .codeContainer{
                width: 50%;
                >div{
                    margin-top: 20px;
                }
                p{
                    font-size: 18px;
                    line-height: 2;
                    color: #666;
                }
                img{
                    width: 176px;
                    height: 176px;
                }
            }
            .guanzhu{
                p{
                    color: #282829;
                    font-size: 22px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/common/contact.vue